export default __webpack_public_path__ + "static/media/alert-circle-red.1003d8e9.svg";